import DeviationMediaService from '../DeviationMediaService';
/**
 * This used to lazyload the hero by using low-res and then upgrading,
 * however web vitals see many heros as the LCP element and lazy loading
 * that element leads to bad scores. We therefore prefer to load the full
 * image early.
 *
 * see useHeroImageForContainer for details on optimisations you need to consider.
 */ export function useHeroImage(deviation, width, height) {
    if (!deviation) {
        return {
            hero: undefined
        };
    }
    var _t_find;
    const hero = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, width, height, // fallback to preview of largest
    (t)=>(_t_find = t.find((i)=>i.type === 'preview')) !== null && _t_find !== void 0 ? _t_find : t[t.length - 1], {
        allowFullview: true,
        allowPreview: true
    });
    return {
        hero
    };
}
